import { FC, useContext } from 'react'
import HorizontalSpinner from '@components/HorizontalSpinner'
import ModalActionButton from '@components/modals/ModalActionButton'
import Status from '@constants/request_statuses'
import { TreeModalContext } from '@components/modals/TreeModal'
import RequestStatus from '@constants/request_statuses'
import { Shareable } from '@app-types/entity_types'
import PublicLinkSharer from './PublishedLinkSharer'

type StartStepProps = {
  shareable?: Shareable
  status: RequestStatus
  error: any
  isPublished: boolean
}

const StartStep: FC<StartStepProps> = ({ shareable, status = RequestStatus.IDLE, isPublished }) => {
  const context = useContext(TreeModalContext)
  const navigateTo = (stepId: string) => {
    if (context) {
      context.navigateTo(stepId)
    }
  }

  let content = null
  if (shareable && status === Status.SUCCEEDED) {
    content = (
      <>
        <PublicLinkSharer
          key="link-sharer"
          shareURI={shareable.share_uri || ''}
          tweetText={shareable.tweet_text || ''}
          resourceType={shareable.type || ''}
          isPublished={isPublished}
        />
        <div>
          {shareable.can_read_permissions && (
            <ModalActionButton onClick={() => navigateTo('permissionsManagement')} label="Permissions & Access" />
          )}
          <ModalActionButton onClick={() => navigateTo('embed')} label="Embed" />
        </div>
      </>
    )
  } else {
    content = (
      <div className="p">
        <HorizontalSpinner size="large" />
      </div>
    )
  }
  return <div className="sharing">{content}</div>
}
export default StartStep
